import React from 'react';

const HiraIdentificationModal = ({ visible, onClose }) => {
  return (
    <div className={`modal_p ${!visible ? 'dsp-n' : ''}`}>
      <section className="back_subheader pt-0">
        <h1 className="fs-20 fw-b font-black pl-20">고유식별 정보 처리 동의</h1>
        <button type="button" className="btn_close" onClick={onClose}></button>
      </section>

      <section
        className="sub_container pt-60"
        style={{
          width: '100%',
          height: '100%',
          overflowY: 'auto', // 스크롤 활성화
        }}
      >
        <ul className="hd_info">
          <li>
            <span>공고일</span>
            2024.08.20
          </li>
          <li>
            <span>개정사항</span>
            약관내용수정
          </li>
          <li>
            <span>시행일</span>
            2024.08.20
          </li>
        </ul>
        <div className="Padding-20 text">
          개인정보보호법 제15조 제1항 제3호에 따라 정보주체의 동의없이 개인정보를 처리합니다.
          <br />
          <br />
          <strong>수집하는 개인정보 항목</strong>
          <br />
          주민등록번호
          <br />
          <br />
          <strong>개인정보 처리 사유</strong>
          <br />
          ‘내가 먹는 약! 한눈에’(개인투약이력조회) 서비스 제공을 위한 본인확인
          <br />
          <br />
          <strong>처리근거</strong>
          <br />
          국민건강보험법 제63조 및 동법 시행령 제81조(의료급여법 시행령 제21조)
        </div>
      </section>
    </div>
  );
};

export default HiraIdentificationModal;
